module.exports = __webpack_public_path__ + "images/emoji/closed_lock_with_key.2dca7c9d821cd9317758.png";